import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ContactsButtonModel } from './contacts-button.model';
import { ContactsItemModel } from './contacts-data-item.model';
import { ContactsButtonTypesEnum } from './contact-button-types.enum';
import { ContactComponentText } from './contact-component-text';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { validateEmail } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

export const contactConstants: any = {
    imageBase64Converter: 'data:image/jpeg;base64,',
    name: 'name',
    address: 'address',
    title: 'title',
    phone: 'phone',
    mobile: 'mobile',
    email: 'email',
    webAddress: 'webAddress',
    ellipses: ' ...',
    images: '/images/'
};

@Component({
    selector: 'agpr-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent implements OnInit {
    @Input() public dataSource: any;
    @Input() public buttons: ContactsButtonModel[];
    @Input() public maxContactItems: number;
    /**
    * The minimum number of contacts
    * If 0, then the component will be added with a contact already created
    */
    @Input() public minContactItems: number = 0;
    @Input() public localization: ContactComponentText = new ContactComponentText();
    @Input() public isDisabled: boolean = false;
    @Input() public isContactDirty: boolean = false;
    @Input() public showImageNormalMode: boolean = false;

    @Input() public mandatoryFields: (keyof ContactsItemModel)[] = [];
    @Input() public showPublishErrors: boolean = false;
    @Input() public showDraftErrors: boolean = false;
    @Input() errorsId: string;
    @Input() public required: boolean = true;
    @Input() public showRequiredMessage: boolean = false;

    @Output() public controlDelete: EventEmitter<any> = new EventEmitter();
    @Output() public isContactDirtyChange: EventEmitter<boolean> = new EventEmitter();
    @Output() getImageError: EventEmitter<string> = new EventEmitter<string>();

    public showImagePlaceholder: boolean = false;
    public showPhone: boolean = false;
    public showMobile: boolean = false;
    public showHeadline: boolean = true;
    public imageUrl: string;
    public imageWidth: number;
    public imageHeight: number;
    public textIndex: number = -1;
    public showContactImageHtml: boolean = false;
    public showContactImageInput: boolean = true;
    public addtype = ContactsButtonTypesEnum.Add;
    public deletetype = ContactsButtonTypesEnum.Delete;
    public contactLost: boolean = false;
    public contactItemDetail: ContactsItemModel = new ContactsItemModel();
    public iscontactError: boolean = false;
    public imageData: string;
    public isImageDirty: boolean = false;
    public mandatory: {[key: string]: boolean} = {};

    readonly buttonTypes = ButtonTypesEnum;


    constructor(
        private sanitizer: DomSanitizer,
        private configurationService: ConfigService
    ) { }

    ngOnInit() {
        this.showImagePlaceholder = true;
        this.imageWidth = 70;
        this.imageHeight = 70;

        if (this.minContactItems > 0) {
            this.dataSource.all().subscribe(
                (contacts) => {
                    if (contacts.length < this.minContactItems) {
                        this.dataSource.addContact(new ContactsItemModel());
                    }
                }
            );
        }

        this.mandatory = {};
        this.mandatoryFields.forEach((value) => {
            this.mandatory[value] = true;
        });
    }

    public openContactBlock(itemIndex: number, item: ContactsItemModel): void {
        if (this.isDisabled) {
            return;
        }
        item.validEmail = validateEmail(item.emailAddress);
        this.textIndex = itemIndex;
        this.contactLost = false;
    }

    add(itemIndex: number) {
        const contactsNewItem = new ContactsItemModel();
        this.dataSource.addContact(contactsNewItem);
        this.textIndex = itemIndex + 1;
    }

    edit(item: ContactsItemModel, itemIndex: number) {
        item.validEmail = validateEmail(item.emailAddress);
        this.textIndex = itemIndex;
    }

    delete(item: ContactsItemModel) {
        this.dataSource.deleteContact(item);
        this.isContactDirtyChange.emit(true);

        this.dataSource.all().subscribe(value => {
            if (!value || value.length === 0) {
                this.onDelete();
                this.textIndex = 0;
            }
        });
    }

    public onContactInput(item, index): void {
        this.dataSource.updateContact(item, index);
        this.isContactDirtyChange.emit(true);
    }

    emitImageError(errorType: string): void {
        this.getImageError.emit(errorType);
    }

    public getBrowsedImage(imageUrl: string, item: ContactsItemModel, index: number): void {
        this.imageData = imageUrl;
        this.showContactImageHtml = true;
        this.showContactImageInput = false;
        item.imageData = imageUrl;
        this.dataSource.updateContact(item, index);
        this.isContactDirtyChange.emit(true);
    }

    public onEdit(): void {
        if (this.isDisabled) {
            return;
        }
        const contactsNewItem = new ContactsItemModel();
        this.dataSource.addContact(contactsNewItem);
        this.textIndex = 0;
        this.contactLost = false;
    }

    public onDelete(): void {
        this.controlDelete.emit();
    }

    public convertBase64ToImage(image: string): SafeUrl {
        if (image != null && image !== '') {
            const imageBase64 = contactConstants.imageBase64Converter + image;
            return this.sanitizer.bypassSecurityTrustUrl(imageBase64);
        }
        return '';
    }

    public unselect() {
        this.showImageNormalMode = true;
        if (this.imageData) {
            this.showContactImageHtml = true;
            this.showContactImageInput = false;
        }
        this.iscontactError = false;
        this.imageData = '';
        this.textIndex = -1;
    }

    public getImageUrlBasedOnImageID(image: string): string {
        if (image != null && image !== '') {
            return this.configurationService.getConfig().apiUrl + contactConstants.images + image;
        }
        return '';
    }

    public emailValidation(item: ContactsItemModel) {
        item.validEmail = validateEmail(item.emailAddress);
    }

}
